export default class RequestCachedError extends Error {}
